import {STORAGE_KEY} from '@app/core/config/app.config';
import {MAP_PERCENTAGE_MOCK} from '@app/core/mock/map-percentage.mock';
import MapPercentage from '@app/core/models/map-percentage.model';
import {BehaviorSubject, of, Subscription} from 'rxjs';
import {distinctUntilChanged, filter, first, shareReplay, tap} from 'rxjs/operators';

const DEFAULT      = 90;
const ALL_SELECTED = 'ALL';

export default class MapPercentageServiceMock {
  private readonly _allEnabled$     = new BehaviorSubject<boolean>(false);
  private readonly _mapPercentage$  = new BehaviorSubject(localStorage.getItem(STORAGE_KEY.mapPercentage) !==
  ALL_SELECTED
    ? JSON.parse(localStorage.getItem(STORAGE_KEY.mapPercentage)) || DEFAULT
    : ALL_SELECTED);
  private readonly _mapPercentages$ = new BehaviorSubject<MapPercentage[]>([]);
  public mapPercentage$             = this._mapPercentage$.asObservable().pipe(distinctUntilChanged());
  public mapPercentages$            = this._mapPercentages$.asObservable().pipe(
    tap(mapPercentage => {
      if (!mapPercentage.length) {
        this.getAll();
      }
    }),
    filter(mapPercentage => Boolean(mapPercentage.length)),
    distinctUntilChanged(),
    shareReplay(1)
  );

  /** Enables option to select All MAP Percentages */
  public enableAll(value: boolean): void {
    this._allEnabled$.next(value);
    if (value) {
      this.updateMapPercentage(ALL_SELECTED);
    } else {
      this.updateMapPercentage(DEFAULT);
    }
  }

  public getAll(): Subscription {
    return of(MAP_PERCENTAGE_MOCK)
      .pipe(first())
      .subscribe(data => this.updateMapPercentages(data));
  }

  public updateMapPercentage(value: number | string): void {
    this._mapPercentage$.next(value);
    localStorage.setItem(STORAGE_KEY.mapPercentage, value.toString());
  }

  public updateMapPercentages(values: MapPercentage[]): void {
    this._mapPercentages$.next(values);
  }
}
